import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Container,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Helmet } from 'react-helmet';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

function Home() {
  const navigate = useNavigate();
  const username = localStorage.getItem('username');

  const updateLastOnline = async () => {
    if (username) {
      try {
        const ref = doc(db, 'users', username);
        await updateDoc(ref, { lastOnline: serverTimestamp() });
      } catch (err) {
        console.error('Error al actualizar lastOnline:', err);
      }
    }
  };

  useEffect(() => {
    updateLastOnline();
  }, []);

  const goToSignUp = () => navigate('/signup');
  const goToLogin = () => navigate('/login');
  const goToGranRifa = () => navigate('/tombola');

  const openYouTube = () =>
    window.open('https://www.youtube.com/shorts/aijwhyShpFg', '_blank');

  const openWhatsApp = () =>
    window.open(
      'https://wa.me/18096245631?text=Hola, mi cuenta ha sido bloqueada y necesito asistencia.',
      '_blank'
    );

  return (
    <>
      <Helmet>
        <title>Chat SRD - Comunidad de Loterías</title>
      </Helmet>

      <Container maxWidth="sm" sx={{ mt: 6, mb: 8 }}>
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}
        >
          {/* LOGO */}
          <Box>
            <img
              src="https://chatsrd.com/logo.png"
              alt="Logo de Chat SRD"
              style={{
                width: '70%',
                maxWidth: '240px',
                borderRadius: '16px',
                boxShadow: '0 6px 15px rgba(0,0,0,0.2)'
              }}
            />
          </Box>

          {/* TARJETA */}
          <Card
            sx={{
              borderRadius: '16px',
              background: '#f4f7fb',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
          >
            <CardContent>
              <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
                ¡Bienvenido a Chat SRD!
              </Typography>

              <Typography variant="body1" color="text.secondary">
                Únete a la comunidad, comparte números, aprende de otros jugadores y
                disfruta de las mejores predicciones diarias.
              </Typography>
            </CardContent>
          </Card>

          {/* BOTONES */}
          <Stack spacing={2} sx={{ width: '100%' }}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
            >
              <Button
                variant="contained"
                onClick={goToSignUp}
                sx={{
                  flex: 1,
                  backgroundColor: '#4caf50',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: '#3a8d3d' }
                }}
              >
                Regístrate
              </Button>

              <Button
                variant="outlined"
                onClick={goToLogin}
                sx={{
                  flex: 1,
                  borderColor: '#4caf50',
                  color: '#4caf50',
                  fontWeight: 'bold',
                  '&:hover': { borderColor: '#3a8d3d', color: '#3a8d3d' }
                }}
              >
                Acceso
              </Button>
            </Stack>

            {/* NUEVO BOTÓN: GRAN RIFA */}
            <Button
              variant="contained"
              onClick={goToGranRifa}
              sx={{
                width: '100%',
                backgroundColor: '#ff9800',
                fontWeight: 'bold',
                borderRadius: '10px',
                '&:hover': { backgroundColor: '#e68900' }
              }}
            >
              🎟 Entra a la Tombola
            </Button>

            <Button
              variant="contained"
              startIcon={<YouTubeIcon />}
              onClick={openYouTube}
              sx={{
                backgroundColor: '#f44336',
                fontWeight: 'bold',
                '&:hover': { backgroundColor: '#d32f2f' }
              }}
            >
              Ver Tutorial en YouTube
            </Button>

            <Button
              variant="outlined"
              startIcon={<WhatsAppIcon />}
              onClick={openWhatsApp}
              sx={{
                borderColor: '#25d366',
                color: '#25d366',
                fontWeight: 'bold',
                '&:hover': { borderColor: '#1fae53', color: '#1fae53' }
              }}
            >
              Soporte por WhatsApp
            </Button>
          </Stack>
        </Box>
      </Container>
    </>
  );
}

export default Home;